export default __webpack_public_path__ + "static/media/SnowMountain1.4f31ae07.mp4";